/**
 * 配置核心文件 (PC端适配版)
 * 整合了环境配置、错误码和错误处理器
 */
import Helper from '@/qingyu/utils/helper'
import { useUserStore } from '@/qingyu/store/pinia/user'
import router from '@/router'

// ==================== 环境配置 ====================
const ENV = {
  // 开发环境配置
  development: {
    // API基础URL
    baseURL: 'https://yq.tatk.net/',
    // 请求超时时间(毫秒)
    timeout: 30000,
    // 是否显示接口错误信息
    showError: true
  },

  // 生产环境配置
  production: {
    // API基础URL
    baseURL: 'https://yq.tatk.net/',
    // 请求超时时间(毫秒)
    timeout: 30000,
    // 是否显示接口错误信息
    showError: true
  }
}

// 导出当前环境的配置
export const currentEnv = ENV[process.env.NODE_ENV || 'development']

// ==================== 错误码定义 ====================
export const ErrorCode = {
  SUCCESS: 200,
  ERROR: 0,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500
}

// 错误处理器
export const ErrorHandler = {
  [ErrorCode.SUCCESS]: (response) => {
    return response.data
  },

  [ErrorCode.UNAUTHORIZED]: (response) => {
    const userStore = useUserStore()
    // 清除用户信息
    userStore.clearUserInfo()

    Helper.tool.showToast({
      title: '登录已过期，请重新登录',
      duration: 2000
    })

    // 跳转到登录页面
    router.replace('/login')

    throw new Error('unauthorized')
  },

  [ErrorCode.FORBIDDEN]: (response) => {
    Helper.tool.showToast({
      title: '无权访问',
      duration: 2000
    })
    throw new Error('forbidden')
  },

  [ErrorCode.NOT_FOUND]: (response) => {
    Helper.tool.showToast({
      title: '请求的资源不存在',
      duration: 2000
    })
    throw new Error('not_found')
  },

  [ErrorCode.SERVER_ERROR]: (response) => {
    Helper.tool.showToast({
      title: '服务器错误',
      duration: 2000
    })
    throw new Error('server_error')
  },

  default: (response) => {
    // 优先使用message字段，如果没有则使用msg字段
    const errorMessage = response.message || response.msg || 'unknown error'

    Helper.tool.showToast({
      title: errorMessage,
      duration: 2000
    })

    throw new Error(errorMessage)
  }
} 